import {
  ButtonHTMLAttributes, MouseEvent, ReactNode
} from "react"

import { Button } from "./_iconButton"

interface IIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  fullWidth?: boolean;
}

export const IconButton = ({
  icon,
  children,
  onClick,
  fullWidth = false,
  ...rest
}: IIconButtonProps) => {

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()

    if (onClick) {
      onClick(event)
    }
  }

  return (
    <Button
      {...rest}
      fullWidth
      onClick={handleClick}
    >
      {icon}
      <p className="icon-button__text">
        {children}
      </p>
    </Button>
  )
}
